
import { lazy } from 'react';
const BayarSewaComponent = lazy(() => import('../../../features/products/presentation/bayar-sewa'));
const VoucherComponent = lazy(() => import('../../../features/products/presentation/kebutuhan-harian'));

const ProductRoutes = [
    {
        billerid: "33",
        component: <VoucherComponent />,
        name: "Voucher Belanja",
        path: "voucherbelanja_page",
    },
    {
        billerid: "42",
        component: <BayarSewaComponent />,
        name: "Bayar Sewa",
        path: "bayarsewa_page",
    },
]
export default ProductRoutes;